import { usePageSEO } from "@/hooks/usePageSEO";
import RomeHeroSection from "./components/HeroSection";
import RomeStickyNav from "./components/StickyNav";
import RomeProcessingTimeSection from "./components/ProcessingTimeSection";
import RomeServicesSection from "./components/ServicesSection";
import RomeHowItWorksSection from "./components/HowItWorksSection";
import RomeLocalAreaSection from "./components/LocalAreaSection";
import RomeAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import RomeComparisonSection from "./components/ComparisonSection";
import RomeMistakesSection from "./components/MistakesSection";
import RomeTestimonialsSection from "./components/TestimonialsSection";
import RomeFAQSection, { faqs } from "./components/FAQSection";
import RomeHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import RomeFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function RomePage() {
  usePageSEO({
    cityName: "Rome",
    route: "/cities/rome",
    description: "Emergency and expedited passport services in Rome, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Floyd County and northwest Georgia travelers. Get your emergency passport fast!",
    geoPlacename: "Rome, Georgia",
    geoPosition: "34.2570;-85.1647",
    keywords: "expedited passport, emergency passport, Rome passport, same day passport Rome, fast passport Georgia, Floyd County passport",
    faqs,
  });

  return (
    <div className="min-h-screen bg-white">
      <RomeHeroSection />
      <RomeStickyNav />
      <RomeProcessingTimeSection />
      <RomeServicesSection />
      <RomeHowItWorksSection />
      <RomeLocalAreaSection />
      <RomeAcceptanceFacilitiesSection />
      <RomeComparisonSection />
      <RomeMistakesSection />
      <RomeTestimonialsSection />
      <RomeFAQSection />
      <RomeHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/rome" state="GA" />
      <RomeFinalCTA />
    </div>
  );
}